import config from "../../../utils/config";

export const getMeasurement = ({
  element,
  currentShape,
  canvasLeft,
  canvasRight,
  canvasTop,
  canvasBottom,
  groupWidth,
  pump_hoger = false,
  pump_vanster = false,
  tileGap,
}) => {
  const elementId = element.getId();

  //Holes and Sink coordinate data
  const data = {
    id: elementId,
    x: element.x(),
    offsetX: element.offsetX(),
    y: element.y(),
    offsetY: element.offsetY(),

    rotation:
      currentShape === "right" &&
      element.y() + element.offsetY() - config.defaultCanvasGap > canvasLeft &&
      [90].includes(element.rotation())
        ? 270
        : [-90].includes(element.rotation()) &&
          element.y() + element.offsetY() >=
            (currentShape === "right" ? canvasLeft : canvasRight)
        ? 90
        : element.y() + element.offsetY() <=
            (currentShape === "right" ? canvasLeft : canvasRight) &&
          ![90, 270].includes(element.rotation())
        ? 180
        : element.rotation(),
  };

  //Sink Holes
  const holeData1 = {
    [`${elementId}-hole-1`]: {
      ...data,
      id: `${elementId}-hole-1`,
      x: [0].includes(element.rotation())
        ? element.x() - groupWidth / 2 + 10
        : [180].includes(element.rotation())
        ? element.x() + groupWidth / 2 - 10
        : data.x,
      y: [90].includes(element.rotation())
        ? element.y() - groupWidth / 2 + 10
        : [270, -90].includes(element.rotation())
        ? element.y() + groupWidth / 2 - 10
        : element.y(),
    },
  };

  const holeData3 = {
    [`${elementId}-hole-3`]: {
      ...data,
      id: `${elementId}-hole-3`,

      x: [0].includes(element.rotation())
        ? element.x() + groupWidth / 2 - 10
        : [180].includes(element.rotation())
        ? element.x() - groupWidth / 2 + 10
        : element.x(),
      y: [90].includes(element.rotation())
        ? element.y() + groupWidth / 2 - 10
        : [270, -90].includes(element.rotation())
        ? element.y() - groupWidth / 2 + 10
        : element.y(),
    },
  };

  /*
    0, 180 => 90,
    90, 270 => 180
  */

  const getRotation = (elementRotation) => {
    let rotation;
    let position;

    if (currentShape === "simple") {
      if (elementRotation === 0) {
        rotation = 270;
        position = "bottomRight";
      }

      if (elementRotation === 90) {
        rotation = 0;
        position = "bottomLeft";
      }

      if (elementRotation === 180) {
        rotation = 270;
        position = "topRight";
      }

      if (elementRotation === 270) {
        rotation = 0;
        position = "bottomRight";
      }
    }

    if (currentShape === "left") {
      if (elementRotation === 0) {
        rotation = 270;
        position =
          element.y() <
          canvasRight - element.offsetY() - tileGap / config.defaultRatio / 2
            ? "bottomRight"
            : "bottomHalfRight";
      }

      if (elementRotation === 90) {
        rotation = 0;
        position = "bottomLeft";
      }

      if (elementRotation === -90) {
        rotation = 0;
        position = "bottomLefttHalf";
      }

      if (elementRotation === 180) {
        rotation = 270;
        position = "topRight";
      }

      if (elementRotation === 270) {
        rotation = 0;
        position = "bottomRight";
      }
    }

    if (currentShape === "right") {
      const isBottom =
        element.y() + element.offsetY() + tileGap / config.defaultRatio / 2 >
        canvasLeft;

      if (elementRotation === 0) {
        if (isBottom) {
          rotation = 270;
          position = "bottomRight";
        } else {
          rotation = 90;
          position = "bottomLeft";
        }
      }

      if (elementRotation === 180) {
        rotation = 270;
        position = "topRight";
      }

      if (elementRotation === 90) {
        if (isBottom) {
          rotation = 0;
          position = "bottomHalfRight";
        } else {
          rotation = 0;
          position = "bottomLeft";
        }
      }

      if (elementRotation === 270) {
        rotation = 180;
        position = "topRight";
      }
    }

    return { rotation, position };
  };
  const holeGapSink = {
    [`${elementId}-holeGapSink`]: {
      ...data,
      id: `${elementId}-holeGapSink`,
      metricType: "tileGap",
      x: tileGap / config.defaultRatio,
      y: tileGap / config.defaultRatio,
      rotation: getRotation(element.rotation()).rotation,
      position: getRotation(element.rotation()).position,
    },
  };

  return {
    [elementId]: data,
    ...(pump_vanster ? holeData1 : {}),
    ...(pump_hoger ? holeData3 : {}),
    ...holeGapSink,
  };
};
